module.exports = __webpack_public_path__ + "static/media/spot11.914b5ea5.webp";